<template>
  <div>
    <span @click.stop="goUrl" class="cursor-pointer hover:italic hover:underline text-primary">{{params.data.Title}}</span>
<!--    <a :href="params.data.SourceUrl" target="_blank">{{ params.data.Title }}</a>-->
  </div>
</template>

<script>
// import authConfig from "../../../../../auth_config.json";

export default {
  name: "LinkCellRenderer",
  methods: {
    goUrl() {
      window.open(this.params.data.SourceUrl, "_blank")
    }
  }
}
</script>

<style scoped>

</style>
